<template>
  <div class="md-layout traveller-extra">
    <div class="md-layout-item md-size-5 extra-compulsory">
      <i
        v-if="extra.compulsory"
        class="far fa-check-circle text-warning tour-type-icon"
        ><md-tooltip md-direction="right"
          >This Extra is Compulsory</md-tooltip
        ></i
      >
    </div>
    <div class="md-layout-item md-size-40 extra-title">
      <md-field class="" slot="inputs">
        <md-input v-model="extra.extra.title" type="text" disabled></md-input>
      </md-field>
    </div>

    <div class="md-layout-item md-size-40 extra-price">
      <md-field class="" slot="inputs">
        <md-input
          v-model="extra.booking_price"
          type="text"
          @input="isDirty = true"
        ></md-input>
      </md-field>
    </div>

    <div class="md-layout-item md-size-15 text-right extra-actions">
      <md-button
        v-if="isDirty"
        class="md-icon-button md-dense md-primary md-simple"
        @click="updateTravellerExtra()"
      >
        <md-icon>save</md-icon>
      </md-button>
      <md-button
        class="md-icon-button md-dense md-danger md-simple"
        @click="removeTravellerExtra()"
      >
        <md-icon>clear</md-icon>
        <md-tooltip md-direction="top"
          >Remove {{ extra.extra.title }} from this Traveller</md-tooltip
        >
      </md-button>
    </div>

    <template>
      <div
        class="md-layout md-layout-item md-size-100 option-value"
        v-for="option in extra.options"
        :key="option.id"
      >
        <div class="md-layout-item md-size-5"></div>
        <div class="md-layout-item md-size-40 option-title">
          <span class="title">{{ option.option.title }}</span>
        </div>
        <div class="md-layout-item md-size-55 option-values">
          <component
            v-bind:is="getOption(option.option.type)"
            :option="option"
            @optionChanged="optionChanged"
          />
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import confirm from "@/helpers/deleteConfirm";

import ExtraOptionSelect from "./Extras/ExtraOptionSelect";
import ExtraOptionText from "./Extras/ExtraOptionText";

export default {
  props: ["traveller", "extra"],

  data() {
    return {
      isDirty: false
    };
  },

  components: {
    ExtraOptionSelect,
    ExtraOptionText
  },

  computed: {},

  methods: {
    getOption(type) {
      return "extra-option-" + type;
    },

    removeTravellerExtra() {
      confirm.delete(null).then(resp => {
        if (resp.value) {
          this.$emit("extraRemoved", this.traveller, this.extra);
        }
      });
    },

    updateTravellerExtra() {
      this.$emit("extraUpdated", this.traveller, this.extra);
      this.isDirty = false;
    },

    optionChanged(option) {
      this.isDirty = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.extra {
  .options {
    margin: 13px 5px;
    padding: 0px 10px;

    li {
      list-style-type: none;
    }
  }
}

.traveller-extra {
  border-top: 1px solid #00bcd4;
  margin-bottom: 0.5em;

  .extra-compulsory {
    display: flex;
    align-items: center;
  }
  .extra-actions {
    align-items: center;
  }
  .md-layout-item {
    padding: 0;
    &.extra-price,
    &.option-values {
      padding-left: 10px;
    }
  }
}
</style>
